import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import logoUrl from './logo.jpg';
import BreadCrumb from './breadCrumb';
import UserInfo from './userInfo';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

class Header extends React.PureComponent {
    static propTypes = {
        headerData: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { headerData } = this.props;

        return (
            <div>
                <div className={styles.header}>
                    <div className={styles.logo}>
                        <a href="//www.ifeng.com/">
                            <LazyImg src={logoUrl} />
                        </a>
                    </div>
                    <BreadCrumb headerData={headerData} />
                    <NoSSR>
                        <UserInfo />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
